import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";
import type { McpPrompt } from "../components/command-palette/types";

/**
 * Sprint 3 — the MCP prompt registry (`prompts/list`), cached for the command
 * palette's "Run prompt" commands. Server-side this is static today (7 prompts)
 * but the capability advertises `listChanged`, so when prompts become
 * user-defined the palette grows automatically — no chrome change needed.
 */
export function useMcpPrompts() {
  return useQuery({
    queryKey: ["mcp-prompts"],
    queryFn: async (): Promise<McpPrompt[]> => {
      const result = await mcpClient.call<{ prompts?: McpPrompt[] }>("prompts/list");
      return result.prompts ?? [];
    },
    staleTime: 60_000,
  });
}
